import axios from "axios";
import { store } from "../App";

const $axios = axios;

$axios.defaults.baseURL = process.env.REACT_APP_SERVER_URL;

$axios.defaults.headers.common["Content-Type"] = "application/json";

$axios.interceptors.request.use((config) => {
  const state = store?.store?.getState();
  const adminToken = state?.auth?.userData?.token;
  config.headers.Authorization = adminToken;

  return config;
});

$axios.interceptors.response.use(
  async (response) => response,
  async (error) => {
    // if (error?.response?.status === 401) {
    //   navigate(NAV_LOGIN);]
    // }
    return Promise.reject(error);
  }
);

export default $axios;
